import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyExchangeRateToAllBookingItem extends BaseCommand {
  Command: {
    Currency: string;
    ExchangeDate: string | null;
    ExchangeRate: number | null;
  };
  constructor(
    sessionId: string,
    operationId: string,
    currency: string,
    exchangeDate: string | null,
    exchangeRate: number | null
  ) {
    super(sessionId, operationId);
    this.Command = {
      Currency: currency,
      ExchangeDate: exchangeDate,
      ExchangeRate: exchangeRate,
    };
  }
}
